import { NavLink, Outlet } from 'react-router';
import { useRoles } from '../context/RolesContext';
import './AdminPage.css';

export default function AdminPage() {
  const { isAdmin, loading } = useRoles();

  if (loading) return null;
  if (!isAdmin) {
    return <p className="admin-access-denied">Access denied. Admin only.</p>;
  }

  return (
    <div className="admin-page">
      <div className="admin-layout">
        <aside className="admin-sidebar">
          <div className="admin-sidebar-title">Admin</div>
          <nav>
            <NavLink
              to="/admin/feedback"
              className={({ isActive }) => `admin-nav-link${isActive ? ' admin-nav-link--active' : ''}`}
            >
              Feedback
            </NavLink>
            <NavLink
              to="/admin/costs"
              className={({ isActive }) => `admin-nav-link${isActive ? ' admin-nav-link--active' : ''}`}
            >
              Costs
            </NavLink>
            <NavLink
              to="/admin/users"
              className={({ isActive }) => `admin-nav-link${isActive ? ' admin-nav-link--active' : ''}`}
            >
              Users
            </NavLink>
            <NavLink
              to="/admin/activity"
              className={({ isActive }) => `admin-nav-link${isActive ? ' admin-nav-link--active' : ''}`}
            >
              Activity
            </NavLink>
            <NavLink
              to="/admin/topics"
              className={({ isActive }) => `admin-nav-link${isActive ? ' admin-nav-link--active' : ''}`}
            >
              Topics
            </NavLink>
            <NavLink
              to="/admin/questions"
              className={({ isActive }) => `admin-nav-link${isActive ? ' admin-nav-link--active' : ''}`}
            >
              Questions
            </NavLink>
          </nav>
        </aside>
        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
